import { FC } from 'react';
import { Box } from './ContentBlock.styled';

const ContentBlock: FC<{ children: React.ReactNode }> = ({ children }) => {
  return <Box>{children}</Box>;
};

export default ContentBlock;
